import { useEffect } from "react";

function Contact() {
  useEffect(() => {
    
    fetch("/links.json")
      .then((res) => res.json())
      .then((data) => {
        const url = data.redirect;
        window.location.href = url;
      })
      .catch((error) => console.error("Error al cargar el link:", error));
  }, []);

  return null;
}

export default Contact;